import React from "react";
import {HashRouter as Router, Redirect} from "react-router-dom";
import {Route, Switch} from './components/Router'
import MainLayout from "@components/layout/MainLayout";
import {FormattedMessage} from "react-intl";
import {DndProvider} from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";


import AliasesIndexPage from '@pages/aliases/index'
import AliasFormPage from "@pages/aliases/AliasFormPage";

import TagsIndexPage from '@pages/tags/index'
import TagFormPage from "@pages/tags/TagFormPage";

import SupplierIndexPage from '@pages/supplier/index'
import SupplierFormPage from "@pages/supplier/SupplierFormPage";
import SuuplierPaymentFormPage from "@pages/supplier/SupplierPaymentFormPage";

import CategoriesIndexPage from '@pages/categories/index'
import CategoryFormPage from "@pages/categories/CategoryFormPage";

import PeopleIndexPage from '@pages/people/index'
import PersonFormPage from "@pages/people/PersonFormPage";
import PeopleRolesPage from '@pages/people/roles'
import PersonRoleFormPage from "@pages/people/PersonRoleFormPage";

import ImagesIndexPage from "@pages/images/index";

import VideosIndexPage from '@pages/videoContents/index'
import VideoContentFormPage from "@pages/videoContents/VideoContentFormPage";
import VideoContextDashboardPage from "@pages/videoContents/VideoContentDashboardPage";
import VideoContentReportPage from "@pages/videoContents/VideoContentReportPage";

import VideosFilesIndexPage from '@pages/videoFiles/index'
import VideoFileFormPage from "@pages/videoFiles/VideoFileFormPage";

import WidgetsIndexPage from "@pages/widgets/index";
import WidgetFormPage from '@pages/widgets/WidgetFormPage';

import UsersIndexPage from "@pages/users/index";
import UserFormPage from "@pages/users/UserFormPage";
import UserRolePage from "@pages/users/roles";
import UserRoleFormPage from "@pages/users/UserRoleFormPage";

import ProvincesIndexPage from "@pages/provinces/index";
import ProvinceFormPage from "@pages/provinces/ProvinceFormPage";

import CitiesIndexPage from '@pages/cities/index'
import CityFormPage from "@pages/cities/CityFormPage";

import QuizzesIndexPage from "@pages/quizzes/index";
import QuizFormPage from "@pages/quizzes/QuizFormPage";
import QuestionsPage from "@pages/quizzes/QuestionsPage";

import JobsIndexPage from "@pages/jobs/index";
import JobFormPage from "@pages/jobs/JobFormPage";

import MenusIndexPage from "@pages/menus/index";
import MenuFormPage from "@pages/menus/MenuFormPage";

import HyperLinkMenusIndexPage from "@pages/hyperLinkMenus/index";
import HyperLinkMenuFormPage from "@pages/hyperLinkMenus/HyperLinkMenuFormPage";

import CommentsIndexPage from '@pages/comments/index'

import TicketsIndexPage from '@pages/tickets/index';

import ChannelsIndexPage from "@pages/channels/index";
import ChannelFormPage from "@pages/channels/ChannelFormPage";
import ConductorsIndexPage from "@pages/conductors/index";
import ConductorFormPage from "@pages/conductors/ConductorFormPage";

import TrackersPoliciesDashboardPage from "@pages/trackerPolicies/Dashboard";
import TrackersPoliciesIndexPage from "@pages/trackerPolicies/index";
import TrackersPolicyFormPage from "@pages/trackerPolicies/TrackerPolicyFormPage";
import TrackerReportPage from "@pages/trackerPolicies/TrackerReportPage";

import DraftsPeopleIndexPage from '@pages/draftsPeople/index'

import SuppliersPaymentsPage from '@pages/reports/SupplierPaymnts'
import SuppliersStatsPage from '@pages/reports/SupplierStats'

import PublicUsersDashboard from '@pages/publicUsers/DashboardPage'
import PublicUsersList from '@pages/publicUsers/ListPage'
import PublicUserReportPage from '@pages/publicUsers/UserReportPage'

import SubscriptionsDashboardPage from '@pages/subscriptions/DashboardPage'
import SubscriptionsListPage from '@pages/subscriptions/ListPage'
import SubscriptionFormPage from "@pages/subscriptions/SubscriptionFormPage";

import PurchasesDashboardPage from '@pages/purchases/DashboardPage'
import PurchasesListPage from '@pages/purchases/ListPage'
import PurchaseFormPage from '@pages/purchases/PurchaseFormPage'


import PaymentsDashboardPage from '@pages/payments/DashboardPage'
import PaymentsReportsPage from '@pages/payments/ReportsPage'
import PaymentTypeReportPage from '@pages/payments/TypeReportPage'
import PaymentGatewayReportPage from '@pages/payments/GatewayReportPage'

import DiscountCodesListPage from '@pages/discountCodes/ListPage'
import DiscountCodeReportPage from '@pages/discountCodes/ReportPage'


import DiscountCodesPoliciesListPage from '@pages/discountCodePolicies/ListPage'
import DiscountCodesPoliciesFormPage from '@pages/discountCodePolicies/FormPage'


import LoginPage from "@pages/login";
import NotFoundPage from "@pages/NotFoundPage";

import ResetPassword from "@pages/resetPassword";
import {Icon} from "antd";
import __i18n from "./intl/__i18n";


export const AppRoutes = [
  {
    path: "/tags",
    key: "/tags",
    label: <FormattedMessage id={"app.tags"}/>,
    exact: true,
    icon: <Icon type="tag"/>,
    component: TagsIndexPage,
    subRoutes: [{
      path: "/tags/:id/edit",
      exact: true,
      component: TagFormPage,
    }, {
      path: "/tags/create",
      exact: true,
      component: TagFormPage,
    }]
  },
  {
    path: "/categories",
    key: "/categories",
    exact: true,
    label: <FormattedMessage id={"app.categories"}/>,
    icon: <Icon type="hdd"/>,
    component: CategoriesIndexPage,
    subRoutes: [{
      path: "/categories/:id/edit",
      exact: true,
      component: CategoryFormPage,
    }, {
      path: "/categories/create",
      exact: true,
      component: CategoryFormPage,
    }]
  },
  {
    path: "/people",
    key: "/people",
    label: <FormattedMessage id={"app.artists"}/>,
    exact: true,
    icon: <Icon type="team"/>,
    component: PeopleIndexPage,
    subRoutes: [{
      path: "/people/:id/edit",
      exact: true,
      component: PersonFormPage,
    }, {
      path: "/people/create",
      exact: true,
      component: PersonFormPage,
    }]
  },
  {
    path: "/people/roles",
    key: "/people/roles",
    exact: true,
    label: <FormattedMessage id={"app.artists_roles"}/>,
    component: PeopleRolesPage,
    icon: <Icon type="reddit"/>,
    subRoutes: [{
      path: "/people/roles/:id/edit",
      exact: true,
      component: PersonRoleFormPage,
    }, {
      path: "/people/roles/create",
      exact: true,
      component: PersonRoleFormPage,
    }]
  },
  {
    path: "/images",
    key: "/images",
    label: <FormattedMessage id={"app.images"}/>,
    exact: true,
    icon: <Icon type="picture"/>,
    component: ImagesIndexPage,
  },
  {
    label: <FormattedMessage id={"app.video_contents"}/>,
    key: "/video-contents",
    icon: <Icon type="video-camera"/>,
    subMenu: [{
      label: __i18n("Report"),
      path: "/video-contents/dashboard",
      exact: true,
      component: VideoContextDashboardPage,
    }, {
      path: "/video-contents",
      label: <FormattedMessage id={"app.video_contents_list"}/>,
      exact: true,
      component: VideosIndexPage,
      subRoutes: [{
        path: "/video-contents/:id/edit",
        exact: true,
        component: VideoContentFormPage,
      }, {
        path: "/video-contents/:id/report",
        exact: true,
        component: VideoContentReportPage,
      }, {
        path: "/video-contents/create",
        exact: true,
        component: VideoContentFormPage,
      }]
    }]
  },
  {
    path: "/video-files",
    key: "/video-files",
    exact: true,
    label: <FormattedMessage id={"app.video_files"}/>,
    icon: <Icon type="youtube"/>,
    component: VideosFilesIndexPage,
    subRoutes: [{
      path: "/video-files/:id/edit",
      exact: true,
      component: VideoFileFormPage,
    }, {
      path: "/video-files/create",
      exact: true,
      component: VideoFileFormPage,
    }]
  },
  {
    path: "/widgets",
    key: "/widgets",
    label: <FormattedMessage id={"app.widgets"}/>,
    exact: true,
    icon: <Icon type="experiment"/>,
    component: WidgetsIndexPage,
    subRoutes: [{
      path: "/widgets/:type/:id/edit",
      exact: true,
      component: WidgetFormPage,
    }, {
      path: "/widgets/create/:type",
      exact: true,
      component: WidgetFormPage,
    }]
  },
  {
    path: "/users",
    key: "/users",
    label: <FormattedMessage id={"app.system_users"}/>,
    exact: true,
    icon: <Icon type="user"/>,
    component: UsersIndexPage,
    subRoutes: [{
      path: "/users/:id/edit",
      exact: true,
      component: UserFormPage,
    }, {
      path: "/users/create",
      exact: true,
      component: UserFormPage,
    }]
  },
  {
    path: "/users/roles",
    key: "/users/roles",
    exact: true,
    icon: <Icon type="reddit"/>,
    label: <FormattedMessage id={"app.system_users_roles"}/>,
    component: UserRolePage,
    subRoutes: [{
      path: "/users/roles/:id/edit",
      exact: true,
      component: UserRoleFormPage,
    }, {
      path: "/users/roles/create",
      exact: true,
      component: UserRoleFormPage,
    }]
  },
  {
    path: "/provinces",
    key: "/provinces",
    exact: true,
    label: <FormattedMessage id={"app.provinces"}/>,
    icon: <Icon type="environment"/>,
    component: ProvincesIndexPage,
    subRoutes: [{
      path: "/provinces/:id/edit",
      exact: true,
      component: ProvinceFormPage,
    }, {
      path: "/provinces/create",
      exact: true,
      component: ProvinceFormPage,
    }]
  },
  {
    path: "/cities",
    key: "/cities",
    exact: true,
    label: <FormattedMessage id={"app.cities"}/>,
    icon: <Icon type="bank"/>,
    component: CitiesIndexPage,
    subRoutes: [{
      path: "/cities/:id/edit",
      exact: true,
      component: CityFormPage,
    }, {
      path: "/cities/create",
      exact: true,
      component: CityFormPage,
    }]
  },
  {
    path: "/jobs",
    key: "/jobs",
    label: <FormattedMessage id={"app.jobs"}/>,
    exact: true,
    icon: <Icon type="tool"/>,
    component: JobsIndexPage,
    subRoutes: [{
      path: "/jobs/:id/edit",
      exact: true,
      component: JobFormPage,
    }, {
      path: "/jobs/create",
      exact: true,
      component: JobFormPage,
    }]
  },
  {
    path: "/menus",
    key: "/menus",
    exact: true,
    label: <FormattedMessage id={"app.menus"}/>,
    icon: <Icon type="menu"/>,
    component: MenusIndexPage,
    subRoutes: [{
      path: "/menus/:id/edit",
      exact: true,
      component: MenuFormPage,
    }, {
      path: "/menus/create",
      exact: true,
      component: MenuFormPage,
    }]
  },
  {
    path: "/hyperLinkMenus",
    key: "/hyperLinkMenus",
    exact: true,
    label: <FormattedMessage id={"app.hyperlinks"}/>,
    icon: <Icon type="link"/>,
    component: HyperLinkMenusIndexPage,
    subRoutes: [{
      path: "/hyperLinkMenus/:id/edit",
      exact: true,
      component: HyperLinkMenuFormPage,
    }, {
      path: "/hyperLinkMenus/create",
      exact: true,
      component: HyperLinkMenuFormPage,
    }]
  },
  {
    path: "/comments",
    key: "/comments",
    label: <FormattedMessage id={"app.comments"}/>,
    exact: true,
    icon: <Icon type="message"/>,
    component: CommentsIndexPage,
  },
  {
    path: "/tickets",
    key: "/tickets",
    label: <FormattedMessage id={"app.tickets"}/>,
    exact: true,
    icon: <Icon type="solution"/>,
    component: TicketsIndexPage,
  },
  {
    path: "/aliases",
    key: "/aliases",
    label: <FormattedMessage id={"app.aliases"}/>,
    exact: true,
    icon: <Icon type="block"/>,
    component: AliasesIndexPage,
    subRoutes: [{
      path: "/aliases/:id/edit",
      exact: true,
      component: AliasFormPage,
    }, {
      path: "/aliases/create",
      exact: true,
      component: AliasFormPage,
    }]
  },
  {
    path: "/draft-people",
    key: "/draft-people",
    label: <FormattedMessage id={"app.draft_people"}/>,
    exact: true,
    icon: <Icon type="smile"/>,
    component: DraftsPeopleIndexPage,
  },
  {
    path: "/channels",
    key: "/channels",
    label: <FormattedMessage id={"app.channels"}/>,
    exact: true,
    icon: <Icon type="desktop"/>,
    component: ChannelsIndexPage,
    subRoutes: [{
      path: "/channels/:id/edit",
      exact: true,
      component: ChannelFormPage,
    }, {
      path: "/channels/create",
      exact: true,
      component: ChannelFormPage,
    }]
  },
  {
    path: "/conductors",
    key: "/conductors",
    label: <FormattedMessage id={"app.conductors"}/>,
    exact: true,
    icon: <Icon type="schedule"/>,
    component: ConductorsIndexPage,
    subRoutes: [{
      path: "/conductors/:id/edit",
      exact: true,
      component: ConductorFormPage,
    }, {
      path: "/conductors/create",
      exact: true,
      component: ConductorFormPage,
    }]
  }, {
    label: <FormattedMessage id={"app.tracker_policies"}/>,
    icon: <Icon type="schedule"/>,
    key: "/tracker-policies",
    subMenu: [{
      path: "/tracker-policies/dashboard",
      label: __i18n("Report"),
      exact: true,
      component: TrackersPoliciesDashboardPage,
    }, {
      path: "/tracker-policies",
      label: <FormattedMessage id={"app.trackers_list"}/>,
      exact: true,
      component: TrackersPoliciesIndexPage,
      subRoutes: [{
        path: "/tracker-policies/:id/report",
        exact: true,
        component: TrackerReportPage,
      }, {
        path: "/tracker-policies/:id/edit",
        exact: true,
        component: TrackersPolicyFormPage,
      }, {
        path: "/tracker-policies/create",
        exact: true,
        component: TrackersPolicyFormPage,
      }]
    }],
  },
  {
    icon: <Icon type="bar-chart"/>,
    label: <FormattedMessage id={"app.suppliers"}/>,
    key: "/suppliers",
    subMenu: [{
      path: "/suppliers",
      label: __i18n("Suppliers List"),
      exact: true,
      component: SupplierIndexPage,
      subRoutes: [{
        path: "/suppliers/:id/edit",
        exact: true,
        component: SupplierFormPage,
      }, {
        path: "/suppliers/create",
        exact: true,
        component: SupplierFormPage,
      }]
    }, {
      path: "/reports/suppliers/payments",
      label: __i18n("Payments"),
      exact: true,
      component: SuppliersPaymentsPage,
      subRoutes: [{
        path: "/suppliers/:supplier_id/payments/:id/edit",
        exact: true,
        component: SuuplierPaymentFormPage,
      }, {
        path: "/suppliers/payments/create",
        exact: true,
        component: SuuplierPaymentFormPage,
      }]
    }, {
      path: "/reports/suppliers/stats",
      label: __i18n("Debits"),
      exact: true,
      component: SuppliersStatsPage,
    }]
  },
  {
    label: <FormattedMessage id={"app.users"}/>,
    icon: <Icon type="team"/>,
    key: "/public-users",
    subMenu: [{
      path: "/public-users/dashboard",
      exact: true,
      label: __i18n("Report"),
      component: PublicUsersDashboard,
    }, {
      path: "/public-users/list",
      label: __i18n("Users List"),
      exact: true,
      component: PublicUsersList,
      subRoutes: [{
        path: "/public-users/:id/report",
        exact: true,
        component: PublicUserReportPage,
      }]
    }]
  },
  {
    label: <FormattedMessage id={"app.subscriptions"}/>,
    icon: <Icon type="shop"/>,
    key: "/subscriptions",
    subMenu: [{
      path: "/subscriptions/dashboard",
      exact: true,
      label: __i18n("Report"),
      component: SubscriptionsDashboardPage,
    }]
  },
  {
    label: <FormattedMessage id={"app.subscriptionslist"} />,
    icon: <Icon type="shop" />,
    key: "/subscriptions-list",
    path: "/subscriptions/list",
    exact: true,
    component: SubscriptionsListPage,
    subRoutes: [{
      path: "/subscriptions/create",
      exact: true,
      component: SubscriptionFormPage,
    }, {
      path: "/subscriptions/:id/edit",
      exact: true,
      component: SubscriptionFormPage,
    }]
  },
  {
    label: <FormattedMessage id={"app.purchases"}/>,
    icon: <Icon type="shopping-cart"/>,
    key: "/purchases",
    subMenu: [{
      path: "/purchases",
      exact: true,
      label: __i18n("Report"),
      component: PurchasesDashboardPage,
    }, {
      path: "/purchases/list",
      label: <FormattedMessage id={"app.purchases_list"}/>,
      exact: true,
      component: PurchasesListPage,
      subRoutes: [{
        path: "/purchases/create",
        exact: true,
        component: PurchaseFormPage,
      }, {
        path: "/purchases/:id/edit",
        exact: true,
        component: PurchaseFormPage,
      }]
    }]
  },
  {
    label: <FormattedMessage id={"app.payments"}/>,
    key: "/payments",
    icon: <Icon type="money-collect"/>,
    subMenu: [{
      path: "/payments",
      label: __i18n("Report"),
      exact: true,
      component: PaymentsDashboardPage,
      subRoutes: [{
        path: "/payments/types/:type/report",
        exact: true,
        component: PaymentTypeReportPage,
      }, {
        path: "/payments/gateways/:gateway/report",
        exact: true,
        component: PaymentGatewayReportPage,
      }]
    }, {
      path: "/payments/reports",
      label: __i18n("Types and Gateways"),
      exact: true,
      component: PaymentsReportsPage,
    }]
  },
  {
    path: "/discount-code-policies",
    key: "/discount-code-policies",
    label: __i18n("Discount Code Policies"),
    exact: true,
    icon: <Icon type="shopping-cart"/>,
    component: DiscountCodesPoliciesListPage,
    subRoutes: [{
      path: "/discount-code-policies/:id/edit",
      exact: true,
      component: DiscountCodesPoliciesFormPage,
    }, {
      path: "/discount-code-policies/create",
      exact: true,
      component: DiscountCodesPoliciesFormPage,
    }]
  },
  {
    path: "/discount-codes",
    key: "/discount-codes",
    exact: true,
    label: <FormattedMessage id={"app.discountCodes"}/>,
    icon: <Icon type="exception"/>,
    component: DiscountCodesListPage,
    subRoutes: [{
      path: "/discount-codes/:id/report",
      exact: true,
      component: DiscountCodeReportPage,
    }]
  },
  // {
  //   path: "/quizzes",
  //   label: <FormattedMessage id={"app.quizzes"}/>,
  //   exact: true,
  //   icon: <Icon type="question-circle" />,
  //   component: QuizzesIndexPage,
  //   subRoutes: [{
  //     path: "/quizzes/:id/edit",
  //     exact: true,
  //     component: QuizFormPage,
  //   }, {
  //     path: "/quizzes/create",
  //     exact: true,
  //     component: QuizFormPage,
  //   },{
  //     path: "/quizzes/:id/questions",
  //     exact: true,
  //     component: QuestionsPage,
  //   }]
  // },
];

const PrivateRoute = ({component: Component, ...rest}) => (
  <Route {...rest} render={(props) => (
    !!localStorage.getItem('user')
      ? <MainLayout menuItems={getUserMenus()}>
        <Component {...props} />
      </MainLayout>
      : <Redirect to='/login'/>
  )}/>
);

export function getUserMenus() {
  const user = JSON.parse(localStorage.getItem('user'));
  const routes = new Set();
  if (user) {
    const {username, roles = []} = user.user_ifo;
    const isAdmin = roles.some(item => item.title === 'Admin')
    if(isAdmin){
      return AppRoutes
    }

    roles.forEach(role => {
      const menus = role.menus || [];
      menus.forEach(menu => {
        const menuItem = AppRoutes.find(item => item.key === menu.url)
        routes.add(menuItem)
      })
    });

    return Array.from(routes);

    const validRoutes = Array.from(routes);
    return validRoutes.map(route => ({
      ...AppRoutes.find(r => r.path === route.url),
      label: route.title
    }));
  }
}

export function getRedirectPath() {
  const user = JSON.parse(localStorage.getItem('user'));
  const menuItems = getUserMenus() || [];

  // const routes = new Set();

  if (user && menuItems.length > 0) {

    if (!!menuItems[0].subMenu) {
      return menuItems[0].subMenu[0].path
    }
    else {
      return menuItems[0].path
    }

    // const routes = getUserMenus();
    // return routes.length > 0 ? routes[0]["path"] : AppRoutes[0].path
  }

  return "/login"
}


function AppRoute(route) {
  const {subRoutes = [], subMenu = [], ...rest} = route;
  const allRoutes = [];
  subMenu.forEach(menu => {
    allRoutes.push(menu)
    if (menu.subRoutes) {
      menu.subRoutes.forEach(opt => {
        allRoutes.push(opt)
      })
    }
  });
  subRoutes.forEach(route => {
    allRoutes.push(route)
  });

  if (!!rest.path) {
    allRoutes.push(rest)
  }

  return allRoutes.map(({path, exact, component}) => (
    <Route
      key={path}
      path={path}
      exact={exact}
      authorize={true}
      component={component}
    />
  ))
}


const App: React.FC<{}> = ({}) => {
  const menuItems = getUserMenus();

  return (
    <DndProvider backend={HTML5Backend}>
      <Router>
        <Switch>
          <Route path="/login" component={LoginPage}/>
          <Route path="/reset_password" component={ResetPassword}/>
          <Route path="/404" component={NotFoundPage}/>

          <MainLayout menuItems={menuItems}>
            {AppRoutes.map((route, index) =>
              <React.Fragment key={route.key}>
                {...AppRoute(route)}
              </React.Fragment>
            )}
          </MainLayout>

          {/*<Redirect from={"/"} to={getRedirectPath()}/>*/}
        </Switch>
      </Router>
    </DndProvider>
  );
};


export default App;


